import { MATERIALS } from './LightingStage';

export function Materials() {
  const mats = MATERIALS.filter((m) => !m.native);
  return (
    <section className="section hairline-t" id="materials">
      <div className="container">
        <div
          className="materials-grid-outer"
          style={{
            display: 'grid',
            gridTemplateColumns: 'minmax(0,0.8fr) minmax(0,1.2fr)',
            gap: 56,
            alignItems: 'center',
          }}
        >
          <div>
            <div className="eyebrow" style={{ marginBottom: 18 }}>
              Surface finishes
            </div>
            <h2 className="h-title" style={{ fontSize: 'clamp(28px,3.2vw,42px)' }}>
              Cast any head
              <br />
              in any material.
            </h2>
            <p className="h-sub" style={{ marginTop: 20 }}>
              Plaster, marble, bronze, wax, obsidian and more. Every finish changes how light rolls
              across the form — the fastest way to train value and reflection.
            </p>
          </div>
          <div
            className="materials-grid"
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '1px',
              background: 'var(--line-1)',
              border: '0.5px solid var(--line-1)',
            }}
          >
            {mats.map((m) => (
              <div
                key={m.id}
                style={{
                  background: 'var(--bg-1)',
                  padding: '20px 18px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 13,
                }}
              >
                <span
                  style={{
                    width: 26,
                    height: 26,
                    borderRadius: '50%',
                    flexShrink: 0,
                    background: `radial-gradient(circle at 32% 28%, #ffffff55, ${m.color} 46%, #000 140%)`,
                    boxShadow:
                      (m.metalness ?? 0) > 0.5
                        ? 'inset 0 0 0 0.5px rgba(255,255,255,0.25)'
                        : 'inset 0 0 0 0.5px rgba(255,255,255,0.08)',
                  }}
                ></span>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 13.5, fontWeight: 500, letterSpacing: '-0.01em' }}>
                    {m.name}
                  </div>
                  <div
                    className="mono"
                    style={{
                      fontSize: 9.5,
                      color: 'var(--fg-3)',
                      marginTop: 1,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {m.sub}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
